import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/components/Top.sass";
import Flag from "../assets/static/flag_bt.png";

const Top = () => {
  const [link, setLink] = useState({});

  useEffect(() => {
    const LinkSession = window.sessionStorage.getItem("menuV2");

    if (!LinkSession) {
      const LLDDLink = fetch(`https://la-leyenda.com/2018/api/enlace-personalizado/1`);
      const CaribeLink = fetch(`https://la-leyenda.com/2018/api/enlace-personalizado/2`);
      const SeriesVolcan = fetch(`https://la-leyenda.com/series-admin-temporal/api/enlace-personalizado/1`);

      Promise.all([LLDDLink, CaribeLink, SeriesVolcan]).then(async ([lldd, caribe, seriesManizales]) => {
        const Links = {
          lldd: await lldd.json(),
          caribe: await caribe.json(),
          seriesManizales: await seriesManizales.json(),
        };

        setLink(Links);
        try {
          window.sessionStorage.setItem("menuV2", JSON.stringify(Links));
        } catch (error) {
          return console.log(error);
        }
      });
    }
    setLink(JSON.parse(LinkSession));
  }, []);

  return (
    <div className="row">
      <div className="col-12 Top">
        <div className="d-block d-lg-none">
          <a id="menu_mobil" href="#my-menu">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="32px"
              height="25px"
              viewBox="0 0 32 32"
            >
              <rect x="1.599" y="1.731" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="13" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="24.268" fill="#000" width="28.803" height="4" />
            </svg>
          </a>
        </div>
        <div className="Top-logo">
          <Link to="/">
            <span className="Top-logo-lldd"></span>
          </Link>
        </div>
        <div className="Top-main-menu d-none d-lg-block">
          <nav>
            <ul className="Top-menu">
              <li className="Top-lldd">
                <a href="https://la-leyenda.com/">
                  LA LEYENDA <br /> DEL DORADO
                </a>
                <div className="Top-lldd-container">
                  <div className="Top-lldd-container-wrap">
                    <b>LA LEYENDA DEL DORADO - CARRERA MTB DE 7 ETAPAS</b>
                    <div className="Top-lldd-grid">
                      <div className="Top-lldd-itema">
                        <a className="Top-lldd-link --red" href={link?.lldd?.url_es}>
                          {link?.lldd?.title_es}
                        </a>
                      </div>
                      <div className="Top-lldd-itemb">
                        <a className="Top-lldd-link" href="https://la-leyenda.com/contact-us">
                          CONTÁCTENOS
                        </a>
                      </div>
                      <div className="Top-lldd-itemc">
                        <p className="text-yellow">INICIO</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://la-leyenda.com/">- La Leyenda Resumen</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/home/packages">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/home/prices">- Precios</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/home/payment">- Plan de pagos</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/home/categories">- Categorías</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/home/testimonials">- Testimonios</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/home/no-excuses">- No hay excusas</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/home/news">- Últimas noticias</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemd">
                        <p className="text-yellow">ACERCA DE LA CARRERA</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://la-leyenda.com/about-us/race_overview">- Descripción de la carrera</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/packages-upgrades">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/categories_and_prizes">- Categorías & Premios</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/charity-entries">- Registros de fundaciones</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/payment-options">- Opciones de pago</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/rules">- Reglamento</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/social-responsibility">- Responsabilidad social</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/safety_and_security">- Seguridad</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/travel">- Viajar</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/about-us/tours">- Tours</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-iteme">
                        <p className="text-yellow">RUTA</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://la-leyenda.com/route/2016/summary">- 2016 Guaduas a Retiro</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/route/2017/summary">- 2017 Caldas</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/route/2018/summary">- 2018 Caldas</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/route/2019/summary">- 2019 Caldas</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/route/2022/summary">- 2022 Valle del Cauca</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/route/2023/summary">- 2023 Caldas</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/route/2024">- 2024 Información</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemf">
                        <p className="text-yellow">CORREDORES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://la-leyenda.com/racers/what_to_pack">- Qué empacar</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/racers/daily_schecdule">- Horario diario</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/racers/tips-and-tricks">- Consejos y trucos</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/racers/jaguares">- Jaguares</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/racers/training">- Entrenamiento</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/results">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemg">
                        <p className="text-yellow">PATROCINADORES Y COLABORADORES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://la-leyenda.com/sponsors-and-partner">- Patrocinadores y colaboradores</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/sponsors-and-partner/become-a-sponsor">
                              - Conviértete en patrocinador
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/sponsors-and-partner/expo-information">
                              - Información de la expo
                            </a>
                          </li>
                        </ul>
                        <p className="mt-4 d-block text-yellow">NOTICIAS & MEDIOS</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://la-leyenda.com/latest-news">- Últimas noticias</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/gallery">- Galería</a>
                          </li>
                          <li>
                            <a
                              href="https://www.youtube.com/channel/UCY4v-WN-1st7I9OjU2ZZXVw"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              - Videos
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/news-and-media/press">- Prensa</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/news-and-media/newsletters">- Boletín de noticias</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemh">
                        <p className="text-yellow">PREGUNTAS FRECUENTES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="https://la-leyenda.com/faqs/race-info">- Info de la carrera</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/logistics">- Logistica</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/registration">- Registro</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/services">- Servicios</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/accommodation">- Alojamiento</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/equipment">- Equipamento</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/insurance">- Seguro</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/cancelation-refunds">- Cancelación y reembolsos</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/faqs/supporters">- Acompañantes</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-aruba">
                <a href="https://www.aruba-la-leyenda.com/">
                  LA LEYENDA <br /> ARUBA
                </a>
              </li>
              <li className="Top-caribe">
                <a href="https://la-leyenda.com/puntacana/">
                  LA LEYENDA <br /> PUNTA CANA
                </a>
                <div className="Top-caribe-container">
                  <div className="Top-caribe-container-wrap">
                    <b> LA LEYENDA PUNTA CANA - CARRERA MTB DE 5 ETAPAS - REPÚBLICA DOMINICANA</b>
                    <div className="Top-caribe-grid">
                      <div className="Top-caribe-itema">
                        <a className="Top-caribe-link" href={link?.caribe?.url_es}>
                          {link?.caribe?.title_es}
                        </a>
                      </div>
                      <div className="Top-caribe-itemb">
                        <a className="Top-caribe-link" href="https://la-leyenda.com/puntacana/contactanos">
                          CONTÁCTENOS
                        </a>
                      </div>
                      <div className="Top-caribe-itemc">
                        <p>INICIO</p>
                        <ul className="Top-caribe-list">
                          <li>
                            <a href="https://la-leyenda.com/puntacana/">- Leyenda Resumen</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/paquetes-y-ascensos">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/precios">- Precios</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/categorias-y-premiacion">
                              - Categorías y Premiación
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/rutas-y-reglamentacion/resumen">
                              - Rutas y Reglamentación
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/patrocinio">- Patrocinio</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-caribe-itemd"></div>
                      <div className="Top-caribe-iteme"></div>
                      <div className="Top-caribe-itemf"></div>
                      <div className="Top-caribe-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-series">
                <a href="https://la-leyenda.com/series">
                  LA LEYENDA <br /> SERIES
                </a>
                <div className="Top-series-container">
                  <div className="Top-series-container-wrap">
                    <b>LA LEYENDA SERIES - EVENTOS MTB DE 1 DÍA</b>
                    <div className="Top-series-grid">
                      <div className="Top-series-itema">
                        <a className="Top-series-link" href="https://la-leyenda.com/series">
                          INICIO
                        </a>
                      </div>
                      <div className="Top-series-itemb">
                        <a className="Top-series-link" href="https://la-leyenda.com/series/contactenos">
                          CONTACTANOS
                        </a>
                      </div>
                      <div className="Top-series-itemc">
                        <p>ZIPAQUIRA 2025</p>
                        <ul className="Top-series-list">
                          <li>
                            <a href={link?.seriesManizales?.url_es} target="blank">
                              - {link?.seriesManizales?.title_es}
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/zipaquira/acerca-de-la-carrera">
                              - Series Zipaquirá resumen
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/zipaquira/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/zipaquira/mtb_carrera">- Rutas</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/zipaquira/categorias">- Categorías</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/zipaquira/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/zipaquira/patrocinio-expo">- Patrocinio y expo</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemd">
                        <p>MANIZALES 2024</p>
                        <ul className="Top-series-list">
                          <li>
                            <a href="https://la-leyenda.com/series/manizales/acerca-de-la-carrera">
                              - Series Manizales resumen
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/manizales/categorias">- Categorías y rutas</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/manizales/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/manizales/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-iteme">
                        <p>CALDAS 2022</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="https://la-leyenda.com/series/caldas/registro">- REGISTRO</a></li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/caldas/acerca-de-la-carrera">
                              - Series Caldas resumen
                            </a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/caldas/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/caldas/categorias-y-rutas">- Categorías y rutas</a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/caldas/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/caldas/patrocinio-expo">
                              - Patrocinio y expo
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/caldas/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/caldas/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemf">
                        <p>CALI 2021</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="https://la-leyenda.com/series/cali/registro">- REGISTRO</a></li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/cali/acerca-de-la-carrera">- Series Cali resumen</a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/cali/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/cali/categorias-y-rutas">- Categorías y rutas</a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/cali/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/cali/patrocinio-expo">
                              - Patrocinio y expo
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/cali/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/cali/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-adventures">
                <Link to="/">
                  LA LEYENDA <br /> ADVENTURES
                </Link>
                <div className="Top-adventures-container">
                  <div className="Top-adventures-container-wrap">
                    <b>LA LEYENDA ADVENTURES - EXPERIENCIAS EN CICLISMO DE LUJO, ORGANIZADAS POR EXPERTOS</b>
                    <div className="Top-adventures-grid">
                      <div className="Top-adventures-itema">
                        <Link className="Top-adventures-link" to="/">
                          INICIO
                        </Link>
                      </div>
                      <div className="Top-adventures-itemb">
                        <Link className="Top-adventures-link" to="/contact-us">
                          CONTÁCTANOS
                        </Link>
                      </div>
                      <div className="Top-adventures-itemc">
                        <Link className="Top-adventures-link" to="/custom-tour">
                          AVENTURA PERSONALIZADO
                        </Link>
                      </div>
                      <div className="Top-adventures-itemd">
                        {/* <Link className="Top-adventures-link" to="/custom-road-tour">TOUR DE CARRETERA PERSONALIZADO</Link> */}
                      </div>
                      <div className="Top-adventures-iteme">
                        <p>
                          AVENTURA DEL CAFÉ <span>MTB - Pereira a Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --coffee">
                          <li>
                            <Link to="/coffee-mtb/tour-overview">- Acerca del tour</Link>
                          </li>
                          <li>
                            <Link to="/coffee-mtb/itinerary/start">- Itinerario</Link>
                          </li>
                          <li>
                            <Link to="/coffee-mtb/package-and-price">- Paquetes y precio</Link>
                          </li>
                          <li>
                            <Link to="/coffee-mtb/upgrades-and-prices">- Ascensos y precios</Link>
                          </li>
                          <li>
                            <Link to="/coffee-mtb/hotels">- Hoteles</Link>
                          </li>
                          <li>
                            <Link to="/coffee-mtb/travel-details">- Detalles del viaje</Link>
                          </li>
                          <li>
                            <Link to="/coffee-mtb/important-info">- Información importante</Link>
                          </li>
                          <li>
                            <a target="_blank" href="https://endurancecui.active.com/event-reg/select-race?e=87019805">
                              - RESERVAR AHORA
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemf">
                        <p>
                          AVENTURA ANTIOQUIA <span>MTB - Medellin a Medellin</span>
                        </p>
                        <ul className="Top-adventures-list --antioquia">
                          <li>
                            <Link to="/antioquia-mtb/tour-overview">- Acerca del tour</Link>
                          </li>
                          <li>
                            <Link to="/antioquia-mtb/itinerary/start">- Itinerario</Link>
                          </li>
                          <li>
                            <Link to="/antioquia-mtb/package-and-price">- Paquetes y precio</Link>
                          </li>
                          <li>
                            <Link to="/antioquia-mtb/upgrades-and-prices">- Ascensos y precios</Link>
                          </li>
                          <li>
                            <Link to="/antioquia-mtb/hotels">- Hoteles</Link>
                          </li>
                          <li>
                            <Link to="/antioquia-mtb/travel-details">- Detalles del viaje</Link>
                          </li>
                          <li>
                            <Link to="/antioquia-mtb/important-info">- Información importante</Link>
                          </li>
                          <li>
                            <Link to="/booknow/antioquia-mtb">- RESERVAR AHORA</Link>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemg">
                        <p>
                          AVENTURA VOLCÁN <span>MTB - Bogotá a Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --volcano">
                          <li>
                            <Link to="/volcano-mtb/tour-overview">- Acerca del tour</Link>
                          </li>
                          <li>
                            <Link to="/volcano-mtb/itinerary/start">- Itinerario</Link>
                          </li>
                          <li>
                            <Link to="/volcano-mtb/package-and-price">- Paquetes y precio</Link>
                          </li>
                          <li>
                            <Link to="/volcano-mtb/upgrades-and-prices">- Ascensos y precios</Link>
                          </li>
                          <li>
                            <Link to="/volcano-mtb/hotels">- Hoteles</Link>
                          </li>
                          <li>
                            <Link to="/volcano-mtb/travel-details">- Detalles del viaje</Link>
                          </li>
                          <li>
                            <Link to="/volcano-mtb/important-info">- Información importante</Link>
                          </li>
                          <li>
                            <Link to="/booknow/volcano-mtb">- RESERVAR AHORA</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
        <div className="Top-redes">
          <a href="https://la-leyenda.com/adventures/en">
            <img className="img-responsive" src={Flag} alt="Idioma Español" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Top;
